
window['ThemeSection_sidebar'] = () => {

  return {
    menu_expanded: true,
    info_expanded: false,
    stockists_expanded: false,
    
    mounted() {
      initTeleport(this.$root);
      Alpine.store('modals').register('nav', 'leftDrawer');
      Alpine.store('modals').register('info', 'rightDrawer');

      Alpine.store('active', 'nsw');
    }
  };
};

window['ThemeComponent_drawer'] = id => {
  const drawerId = 'drawer_' + id;
  return {
    mounted() {
      initTeleport(this.$root);
      Alpine.store('modals').register(drawerId, 'contentDrawer');
    }
  };
};
